/* eslint-disable no-restricted-syntax */
/* eslint-disable no-console */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-param-reassign */
import * as L from 'leaflet';
import 'src/libs/Leaflet.draw/leaflet.draw';
import 'src/libTypes/leaflet-draw/index.d';
import 'src/libs/Leaflet.draw/leaflet.draw.css';
import { CustomColorPicker } from 'src/app/helpers/customColorPicker';
import { MapViewState } from 'src/enums/map.enum';
/* eslint no-underscore-dangle: 0 */
import { drawenLayerHelper, statusHelper, geoJsonSocketHelper } from 'src/app/helpers';
import { DrawGeoFilterMap, DrawenLayerResultType, DrawenLayerSocketEvent } from 'src/app/helpers/drawenLayer.helper';
import { CustomDrawGroupPicker } from 'src/app/helpers/customDrawGroupPicker';
import React from 'react';
import {
  layerToGeojson,
  dbDataToGeojsonLayer,
  ControllerLayersContainer,
  registerLayer,
  unregisterLayer,
  unregisterLayersByGroupId,
  drawingOptions,
} from 'src/controllers/config';
import { DrawControllerActiveLayers } from 'src/app/components/MapComponent/plugins/DrawControllerActiveLayers';
import { DrawenLayerGroupResultType } from 'src/types/components/draw-module.type';
import { drawenLayerGroupService } from 'src/app/services';
import { MapController } from 'src/controllers/MapController';
// @ts-ignore
window.type = 'true';

const defaultColor = '#000000';
const customColorPicker = new CustomColorPicker();
const customDrawGroupPicker = new CustomDrawGroupPicker();
const activeLayersControl = new DrawControllerActiveLayers({ position: 'topleft' });

let drawLeafletController: L.Control.Draw | undefined;

export class DrawController extends MapController {
  editableLayers: L.FeatureGroup<L.GeoJSON> | undefined;

  activeLayersControl: DrawControllerActiveLayers | undefined;

  // tarafId ve userRole controllera aktarmak için oluşturulmuş object'dir.
  drawGeoFilterMap?: DrawGeoFilterMap;

  // Layer button tıklanmasına bakmak için oluşturulmuş boolean değerdir.
  eventsBoundStatus: boolean = false;

  // create işleminde ts dosyası ile react konuşturmak amaçlı state'i alıp popup kontrolü sağlamak amaçlı kullanılmıştır.
  setIsDrawGroupModalPopupOpen?: React.Dispatch<React.SetStateAction<boolean>>;

  // create işleminde Modal açılmışmı açılmamışmı onun kontrolünü sağlamak için oluşturulmuş boolean değerdir.
  isOpenPopup: boolean = false;

  // oluşturulan  geoJson verisinin idsini almak için ve react ile konuşturmak için yazılmış setStatedir.
  setCreateGeoJsonGetId?: React.Dispatch<React.SetStateAction<number | undefined>>;

  // drawGroup için oluşturulmuş bir arraydir.
  layerData: ControllerLayersContainer = {};

  onDrawLayerCreated?: (layer: any) => void;

  activeGroupIds = new Set<number>();

  tempCreatedLayer: any;

  drawGroups: DrawenLayerGroupResultType[] = [];

  setDrawGroups: React.Dispatch<any> | undefined;

  rotateModalData: any;

  setRotateModal: React.Dispatch<any> | undefined;

  deleteMode: boolean = false;

  editMode: boolean = false;

  // isDrawing: boolean = false;

  labelMarkersMap: Map<string, L.Marker> = new Map();

  constructor(map: L.Map) {
    super(map, MapViewState.Default);
  }

  init = (
    drawGeoMapFilter: DrawGeoFilterMap,
    onDrawLayerCreated: (layer: any) => void,
    setRotateModal?: React.Dispatch<any>,
    setDrawGroups?: React.Dispatch<any>,
  ) => {
    drawLeafletController = undefined;
    this.drawGeoFilterMap = drawGeoMapFilter;
    this.onDrawLayerCreated = onDrawLayerCreated;
    this.isOpenPopup = false;
    this.eventsBoundStatus = false;
    this.setRotateModal = setRotateModal;
    this.setDrawGroups = setDrawGroups;
    this.setDrawLeafletController();
    this.setDrawOptions();
    this.bindEvents();
  };

  setDrawGeoFilterMap = (tarafId: number | undefined) => {
    if (!this.drawGeoFilterMap) return;
    this.drawGeoFilterMap.tarafId = tarafId;
  };

  setDrawGroupsData = (data: DrawenLayerGroupResultType[]) => {
    this.drawGroups = data;
  };

  setRotateModalData = (data: any) => {
    this.rotateModalData = data;
  };

  setEditMode = (editMode: boolean) => {
    this.editMode = editMode;
  };

  // setIsDrawing = (isDrawing: boolean) => {
  //   this.isDrawing = isDrawing;
  // };

  updateActiveLayersController = () => {
    const activeLayerTexts = Array.from(this.activeGroupIds).map(
      (o) => this.drawGroups.find((a) => a.id === o)?.text || '',
    );

    activeLayersControl.updateContext(activeLayerTexts);
  };

  createSocketConnection = (veritabaniId: number, tarafId?: number) => {
    drawenLayerHelper.createGeoJsonSocketConnection(
      this.socketListenCallbackCreate,
      this.socketListenCallbackUpdateDelete,
      veritabaniId,
      tarafId,
    );
  };

  socketListenCallbackCreate = (data: DrawenLayerSocketEvent) => {
    switch (data.status) {
      case 'ADD':
        this.socketOnLayerCreated(data.data, data.drawenLayerGroupIds);
        break;

      case 'UPDATE':
        this.socketOnLayerUpdated(data.data);
        break;

      case 'DELETE':
        this.socketOnLayerDeleted(data.data);
        this.deleteLayerGroupfromDrawGroups(Number(data.data));
        break;

      case 'DELETEMANY':
        this.socketOnLayersDeleted(data.data, data?.drawenLayerGroupIds || []);
        break;

      case 'COPY':
        this.socketOnLayerCreated(data.data, data.drawenLayerGroupIds);
        break;

      case 'UPDATEPRIVILEGES':
        this.socketLayerPrivileges(data.data.data, data.drawenLayerGroupIds, data.data.tarafId);
        break;

      default:
        break;
    }
  };

  socketListenCallbackUpdateDelete = async (data: DrawenLayerSocketEvent) => {
    switch (data.status) {
      case 'ADD':
        this.socketOnLayerCreated(data.data, data.drawenLayerGroupIds);
        break;

      case 'UPDATE':
        this.socketOnLayerUpdated(data.data);
        break;

      case 'DELETE':
        this.socketOnLayerDeleted(data.data);
        this.deleteLayerGroupfromDrawGroups(Number(data.data));
        break;

      case 'DELETEMANY':
        this.socketOnLayersDeleted(data.data, data?.drawenLayerGroupIds || []);
        break;

      case 'COPY':
        this.socketOnLayerCreated(data.data, data.drawenLayerGroupIds);
        break;

      case 'UPDATEPRIVILEGES':
        this.socketLayerPrivileges(data.data.data, data.drawenLayerGroupIds, data.data.tarafId);
        break;

      default:
        break;
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  socketLayerPrivileges = async (payload: any, groupIds: number[], tarafId: number) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { data: getAll } = await drawenLayerGroupService.getAllLayers();
  };

  socketOnLayerCreated = (payload: DrawenLayerResultType, groupIds: number[]) => {
    try {
      const activeGroupIdsArray = Array.from(this.activeGroupIds);
      const affectedGroupIds = groupIds.filter((groupId) => this.activeGroupIds.has(groupId));

      if (affectedGroupIds.length === 0) return;

      let shouldRender = false;

      const updatedDrawGroups = [...this.drawGroups];

      for (let i = 0; i < updatedDrawGroups.length; i += 1) {
        const group = updatedDrawGroups[i];
        if (affectedGroupIds.includes(group.id)) {
          const result = registerLayer(this.layerData, payload, payload.uuid, group.id, activeGroupIdsArray);
          if (result.shouldDrawLayer) {
            shouldRender = true;
          }
          updatedDrawGroups[i] = {
            ...group,
            drawenLayers: [...group.drawenLayers, payload],
          };
        }
      }
      this.setDrawGroupsData(updatedDrawGroups);
      this.setDrawGroups?.(updatedDrawGroups);

      if (shouldRender) {
        dbDataToGeojsonLayer(this.map, payload.features, this.onEachFeature);
      }
    } catch (error) {
      console.error('SOCKET: Error while handling layer creation:', error);
    }
  };

  socketOnLayerUpdated = (payload: DrawenLayerResultType) => {
    const activeGroups = [];
    for (let i = 0; i < this.drawGroups.length; i += 1) {
      if (this.activeGroupIds.has(this.drawGroups[i].id)) {
        activeGroups.push(this.drawGroups[i]);
      }
    }
    let layerFound = false;

    const updatedActiveGroups = [];
    for (let i = 0; i < activeGroups.length; i += 1) {
      const group = activeGroups[i];
      const updatedLayers = [];

      for (let j = 0; j < group.drawenLayers.length; j += 1) {
        const layer = group.drawenLayers[j];
        if (layer.uuid === payload.uuid) {
          layerFound = true;
          updatedLayers.push({
            ...layer,
            ...payload,
          });
        } else {
          updatedLayers.push(layer);
        }
      }

      updatedActiveGroups.push({
        ...group,
        drawenLayers: updatedLayers,
      });
    }

    const updatedDrawGroups = [];
    for (let i = 0; i < this.drawGroups.length; i += 1) {
      const group = this.drawGroups[i];
      let updatedGroup = null;

      for (let j = 0; j < updatedActiveGroups.length; j += 1) {
        if (updatedActiveGroups[j].id === group.id) {
          updatedGroup = updatedActiveGroups[j];
          break;
        }
      }

      updatedDrawGroups.push(updatedGroup ?? group);
    }
    // console.log('SOCKET UPDATE : updatedDrawGroups', updatedDrawGroups);
    this.setDrawGroupsData(updatedDrawGroups);
    this.setDrawGroups?.(updatedDrawGroups);

    if (layerFound) {
      // console.log('SOCKET UPDATE: Layer found, updating map.');
      // Haritadaki eski layerı silip yenisini ekle
      this.deleteLayer(payload.uuid);
      dbDataToGeojsonLayer(this.map, payload.features, this.onEachFeature);
    }
  };

  socketOnLayerDeleted = (uuid: string) => {
    this.deleteLayer(uuid);
    delete this.layerData[uuid];
  };

  socketOnLayersDeleted = (uuidArray: string[], groupIds: number[]) => {
    uuidArray.forEach((uuid) => {
      this.deleteLayer(uuid);
      delete this.layerData[uuid];
    });
    const updatedDrawGroups = this.drawGroups.map((group) => {
      if (groupIds.includes(group.id)) {
        return {
          ...group,
          drawenLayers: group.drawenLayers.filter((layer) => !uuidArray.includes(layer.uuid)),
        };
      }
      return group;
    });
    // this.setDrawGroupsData(updatedDrawGroups);
    this.setDrawGroups?.(updatedDrawGroups);
  };

  getShapeCenter = (edited: L.Polygon | L.Polyline) => {
    if (edited instanceof L.Polygon) {
      const center = edited.getBounds().getCenter();
      return center;
    }
    const center = edited.getBounds().getCenter();
    return center;
  };

  // Controllerları ve featuregroup'u mape eklemek için kullanılır.
  setDrawLeafletController = () => {
    this.editableLayers = L.featureGroup();
    this.map.addLayer(this.editableLayers);
    L.EditToolbar.Delete.include({
      removeAllLayers: false,
    });

    if (drawLeafletController === undefined) {
      drawLeafletController = new L.Control.Draw({
        position: 'topleft',
        edit: {
          featureGroup: this.editableLayers,
          remove: true,
        },
      });
    }

    this.map.addControl(activeLayersControl);
    this.map.addControl(customDrawGroupPicker);
    this.map.addControl(customColorPicker);
    this.map.addControl(drawLeafletController);

    // when “Edit” starts
    this.map.on(L.Draw.Event.EDITSTART, () => {
      this.setEditMode(true);
      this.handleCopyOnEditStart();
      this.setRotateModal?.(undefined);
    });

    // when “Edit” ends, remove markers
    this.map.on(L.Draw.Event.EDITSTOP, this.handleCopyOnEditStop);

    // on save
    this.map.on('draw:edited', async (e: any) => {
      this.setEditMode(false);
      await this.drawControllerUpdateEvent(e);
      this.handleCopyOnEditStop();
    });

    // on cancel (or after save)
    this.map.on(L.Draw.Event.EDITSTOP, () => {
      this.setEditMode(false);
      this.handleCopyOnEditStop();
    });

    const domCustomColorPicker = document.querySelector('#customColorPicker');
    if (domCustomColorPicker) {
      (domCustomColorPicker as HTMLInputElement).addEventListener('onChange', (e) => {
        // @ts-ignore
        this.setDrawOptions(e?.target?.value);
      });
    }
  };

  setDrawOptions = (drawColor: string = defaultColor) => {
    drawLeafletController?.setDrawingOptions(drawingOptions(drawColor));
  };

  deleteLayer = (uuid: string) => {
    const layer = this.findLayerByUUID(uuid);

    if (layer) {
      this.editableLayers?.removeLayer(layer);
    }
  };

  findLayerByUUID = (uuid: string) => {
    // @ts-ignore
    return this.editableLayers?.getLayers().find((o) => (o as L.GeoJSON).feature?.properties?.uuid === uuid);
  };

  // GeoJsona çevrilmiş bir layer'ın myTag diye yeni bir değişken ekletmemize yarar.
  onEachFeature = async (feature: any, layer: any) => {
    layer.myTag = 'drawenLayerGeoJSON';
    if (feature.properties && feature.properties.popupContent) {
      layer.bindPopup(feature.properties.popupContent);
    }

    const isTextFeature = feature.properties?.isLabel || false;
    // const isMarkerCircle = (feature.geometry?.type === 'Point' && feature.properties.radius === 10) || false;
    // const isMarker = feature.geometry?.type === 'Point' && !feature.properties.radius;

    if (!isTextFeature) {
      const featureName = feature.properties?.name || '-';
      layer.on('mouseover', () => {
        layer
          .bindTooltip(featureName, {
            direction: 'top',
            offset: [0, -10],
            permanent: false,
            sticky: true,
            interactive: true,
          })
          .openTooltip();
      });

      layer.on('mouseout', () => {
        if ((layer as any)._map) {
          layer.closeTooltip();
        }
      });
    }
    // if (!isTextFeature && !isMarkerCircle && !isMarker) {
    layer.on('click', () => {
      if (this.deleteMode || !this.setRotateModal || this.editMode) return;

      this.setRotateModal({
        feature,
        map: this.map,
        layer,
      });
    });
    // }

    if (feature.geometry && feature.geometry.type === 'LineString' && layer instanceof L.Polyline) {
      // 1. arrowHead özelliği: çizgi boyunca tekrar eden oklar
      if (feature.properties.arrowHead) {
        layer.arrowheads({
          size: '13px',
          frequency: '60px',
          fill: feature.properties.arrowFillType,
        });
      }

      // 2. startEndArrow özelliği: başlangıç ve bitiş okları
      if (feature.properties.startEndArrow) {
        // Başlangıç oku
        if (feature.geometry.coordinates && feature.geometry.coordinates.length >= 2) {
          const reversedCoords = [...feature.geometry.coordinates].reverse();
          const reversedLine = L.polyline(
            reversedCoords.map((c) => [c[1], c[0]]),
            { opacity: 0, color: feature.properties.style?.color },
          );
          (layer as any)._reversedLine = reversedLine;

          reversedLine.arrowheads({
            size: '13px',
            frequency: 'endonly',
            fill: feature.properties.arrowFillType,
            yawn: 50,
            color: feature.properties.style?.color,
            fillColor: feature.properties.style?.color,
            opacity: feature.properties.style?.opacity ?? feature.properties.style?.fillOpacity,
            fillOpacity: feature.properties.style?.opacity ?? feature.properties.style?.fillOpacity,
          });

          layer.on('add', (e) => {
            const map = e.target._map;
            if (!map) return;
            // recalc from the *current* layer geometry
            const ll = (layer as L.Polyline).getLatLngs() as L.LatLng[];
            const rev = ll.slice().reverse();
            reversedLine.setLatLngs(rev);
            reversedLine.addTo(map).bringToBack();
          });

          layer.on('remove', (e) => {
            const map = e.target._map;
            if (map && map.hasLayer(reversedLine)) {
              map.removeLayer(reversedLine);
            }
          });
        }
        // Bitiş oku
        layer.arrowheads({
          size: '13px',
          frequency: 'endonly',
          fill: feature.properties.arrowFillType,
          yawn: 50,
          color: feature.properties.style?.color,
          fillColor: feature.properties.style?.color,
          opacity: feature.properties.style?.opacity ?? feature.properties.style?.fillOpacity,
          fillOpacity: feature.properties.style?.opacity ?? feature.properties.style?.fillOpacity,
        });
      }
    }
    this.editableLayers?.addLayer(layer);
  };

  // Shift a Polygon’s or Polyline’s latlngs by (dLat, dLng)
  shiftLatlngs(latlngs: L.LatLng[] | L.LatLng[][], dLat: number, dLng: number) {
    if (Array.isArray(latlngs[0])) {
      return (latlngs as L.LatLng[][]).map((r) => r.map((p) => L.latLng(p.lat + dLat, p.lng + dLng)));
    }
    return (latlngs as L.LatLng[]).map((p) => L.latLng(p.lat + dLat, p.lng + dLng));
  }

  // Called on EDITSTART
  handleCopyOnEditStart = () => {
    this.editableLayers?.eachLayer((layer) => {
      if (!(layer instanceof L.Polygon || layer instanceof L.Polyline)) return;
      const poly = layer as L.Polygon | L.Polyline;

      // Store original geometry for cancel/restore
      const originalLatLngs = JSON.parse(JSON.stringify(poly.getLatLngs()));
      let currentLatlngs = JSON.parse(JSON.stringify(poly.getLatLngs())) as L.LatLng[] | L.LatLng[][];
      // before creating the drag-handle, compute the shape’s “center”
      let currentCenter = this.getShapeCenter(poly);

      if (poly instanceof L.Polyline && !(poly instanceof L.Polygon)) {
        // project that center into pixel-space on the map:
        const cp = this.map.latLngToLayerPoint(currentCenter);
        // find the closest point *on* the polyline
        const clp = (poly as any).closestLayerPoint(cp);
        if (clp) {
          // if we got a valid point, turn it back into lat/lng
          currentCenter = this.map.layerPointToLatLng(clp);
        }
        // otherwise leave currentCenter as the original bounds-center
      }

      // Create the drag handle
      const icon = L.divIcon({
        html: `<div style="width:25px;height:25px;background-color:rgb(226,225,225);border:2px solid black;border-radius:2px;cursor:move"></div>`,
        className: 'custom-drag-point',
        iconSize: [25, 25],
        iconAnchor: [12.5, 12.5],
      });
      const copyMarker = L.marker(currentCenter, { draggable: true, icon }).addTo(this.map);

      (poly as any)._copyMarker = copyMarker;
      (poly as any)._originalLatLngs = originalLatLngs;
      (poly as any)._wasRemoved = false;

      let preview: L.Polygon | L.Polyline | null = null;
      const reversedLine = (poly as any)._reversedLine;
      // Listen just to edits on this polygon/polyline
      const onVertexEdit = (e: any) => {
        if (e.poly !== poly) return;

        // Grab the fresh coords & recalc center
        currentLatlngs = JSON.parse(JSON.stringify(poly.getLatLngs()));
        currentCenter = this.getShapeCenter(poly);

        // Update preview shape
        if (preview) {
          preview.setLatLngs(currentLatlngs as any);
        }
        // Move drag handle
        copyMarker.setLatLng(currentCenter);
        if (reversedLine) {
          const ll = (poly as L.Polyline).getLatLngs() as L.LatLng[];
          reversedLine.setLatLngs(ll.slice().reverse());
        }
      };
      this.map.on(L.Draw.Event.EDITVERTEX, onVertexEdit);

      // Marker drag-start event: remove original shape
      copyMarker.on('dragstart', () => {
        if (!(poly as any)._wasRemoved) {
          this.editableLayers?.removeLayer(poly);
          this.map.removeLayer(poly);
          (poly as any)._wasRemoved = true;
        }
      });

      // Marker dragging event: show a dashed preview
      copyMarker.on('drag', (e: L.LeafletEvent) => {
        const newC = (e.target as L.Marker).getLatLng();
        const dLat = newC.lat - currentCenter.lat;
        const dLng = newC.lng - currentCenter.lng;
        const shifted = this.shiftLatlngs(currentLatlngs, dLat, dLng);

        if (!preview) {
          const opts = { ...(poly as any).options, opacity: 0.3, dashArray: '5,5' };
          preview =
            poly instanceof L.Polygon
              ? L.polygon(shifted as L.LatLng[][], opts)
              : L.polyline(shifted as L.LatLng[], opts);
          preview.addTo(this.map);
        } else {
          preview.setLatLngs(shifted as any);
        }
      });

      // Marker drag-end: commit the shape and cleanup
      copyMarker.on('dragend', (e: L.DragEndEvent) => {
        const newC = (e.target as L.Marker).getLatLng();
        const dLat = newC.lat - currentCenter.lat;
        const dLng = newC.lng - currentCenter.lng;
        const shifted = this.shiftLatlngs(currentLatlngs, dLat, dLng);

        // Remove preview + ensure original is gone
        if (preview) {
          this.map.removeLayer(preview);
          this.map.removeLayer(poly);
          preview = null;
        }

        // Apply new coords and re-add
        poly.setLatLngs(shifted as any);
        if ((poly as any)._wasRemoved) {
          this.editableLayers?.addLayer(poly);
          poly.addTo(this.map);
          (poly as any)._wasRemoved = false;
        }

        // Update state & reposition handle
        currentLatlngs = shifted;
        currentCenter = this.getShapeCenter(poly);
        copyMarker.setLatLng(currentCenter);

        if (reversedLine) {
          const ll = (poly as L.Polyline).getLatLngs() as L.LatLng[];
          reversedLine.setLatLngs(ll.slice().reverse()).bringToBack();
        }

        // Trigger vertex update to reflect new coordinates
        this.map.fire(L.Draw.Event.EDITVERTEX, { poly });

        // Stop listening for vertex edits on this shape
        this.map.off(L.Draw.Event.EDITVERTEX, onVertexEdit);
        (poly as any).editing.disable();
      });
    });
  };

  handleCopyOnEditStop = () => {
    this.editableLayers?.eachLayer((layer: any) => {
      // clean up the drag handle
      if (layer._copyMarker) {
        layer._copyMarker.remove();
        delete layer._copyMarker;
      }

      //  edit or cancel restore coords
      if (layer._wasRemoved) {
        if (layer._originalLatLngs) {
          layer.setLatLngs(layer._originalLatLngs);
        }
        this.editableLayers?.addLayer(layer);
        layer.addTo(this.map);
        layer._wasRemoved = false;
      }

      //  add startEndArrow reversed‐line if needed
      if (layer.feature?.properties?.startEndArrow) {
        // remove any old reversedLine
        if (layer._reversedLine && this.map.hasLayer(layer._reversedLine)) {
          this.map.removeLayer(layer._reversedLine);
        }
        // recompute the reversed coords from the main coords
        const pts = (layer as L.Polyline).getLatLngs() as L.LatLng[];
        const revCoords = pts
          .slice()
          .reverse()
          .map((p) => [p.lat, p.lng]);
        // create a new polyline with the reversed coords
        const reversedLine = layer._reversedLine
          ? layer._reversedLine.setLatLngs(revCoords)
          : L.polyline(revCoords as L.LatLngTuple[], { opacity: 0, color: layer.feature.properties.style?.color });
        // draw the arrowhead on it
        reversedLine.arrowheads({
          size: '13px',
          frequency: 'endonly',
          fill: true,
          yawn: 50,
        });
        // add it back behind the main line
        reversedLine.addTo(this.map).bringToBack();
        // store for next time
        layer._reversedLine = reversedLine;
      }

      // 4) clean up temp props
      delete layer._originalLatLngs;
      delete layer._wasRemoved;
    });
  };

  // Gruba bağlı layerları geojsona çevirip mape ekler.
  showLayerGroupLayers = (groupId: number, drawenLayers?: DrawenLayerResultType[]) => {
    this.activeGroupIds.add(groupId);
    this.updateActiveLayersController();

    drawenLayers?.forEach((drawenLayer) => {
      const { uuid } = drawenLayer;
      const result = registerLayer(this.layerData, drawenLayer, uuid, groupId, Array.from(this.activeGroupIds));

      if (result.shouldDrawLayer) {
        dbDataToGeojsonLayer(this.map, drawenLayer.features, (feature: GeoJSON.Feature, layer: L.Layer) => {
          this.onEachFeature(feature, layer);
        });
      }

      // If it's a label marker and exists in memory, re-add to map
      const labelMarker = this.labelMarkersMap.get(uuid);
      if (labelMarker) {
        labelMarker.addTo(this.map);
      }
    });
  };
  // findAndDrawDeleteLayerGroupLayers = () => {

  hideLayersByGroupId = (groupId: number) => {
    this.activeGroupIds.delete(groupId);
    this.updateActiveLayersController();

    const layersResults = unregisterLayersByGroupId(this.layerData, groupId);
    layersResults.forEach((layersResult) => {
      if (layersResult.shouldRemoveLayer) {
        this.deleteLayer(layersResult.uuid);

        // Also remove text label marker if exists
        const labelMarker = this.labelMarkersMap.get(layersResult.uuid);
        if (labelMarker) {
          this.map.removeLayer(labelMarker);
        }

        delete this.layerData[layersResult.uuid];
      }
    });
  };

  deleteLayerGroupfromDrawGroups = (groupId: number) => {
    const updatedDrawGroups = this.drawGroups.filter((group) => group.id !== groupId);
    // this.setDrawGroupsData(updatedDrawGroups);
    this.setDrawGroups?.(updatedDrawGroups);
  };

  // drawControllerEventsdeki draw:deleted fonksiyonuna gelen layeri kaldırmamızı sağlar.
  hideLayer = (uuid: string, groupId: number) => {
    const result = unregisterLayer(this.layerData, uuid, groupId);
    if (result.shouldRemoveLayer) {
      this.activeGroupIds.delete(groupId);
      this.updateActiveLayersController();
      this.deleteLayer(uuid);
      delete this.layerData[uuid];
    }
  };

  // drawControllerEventsdeki draw:deleted fonksiyonuna gelen layeri id ile kaldırmamızı sağlar.
  removeLayerByUUID = (uuid: string, groupId: number) => {
    const result = unregisterLayer(this.layerData, uuid, groupId);
    if (result.shouldRemoveLayer) {
      this.activeGroupIds.delete(groupId);
      this.updateActiveLayersController();
      this.deleteLayer(uuid);
      delete this.layerData[uuid];
    }
  };

  // diğer kullanılar tarafından görülmesin diye socket işleminde yer almadan create layer işlemi sağlar.
  createLayer = async (payload: DrawenLayerResultType, groupIds: number[]) => {
    this.tempCreatedLayer.remove();

    for (const groupId of groupIds) {
      if (this.activeGroupIds.has(groupId)) {
        const result = registerLayer(this.layerData, payload, payload.uuid, groupId, Array.from(this.activeGroupIds));

        if (result.shouldDrawLayer) {
          dbDataToGeojsonLayer(this.map, payload.features, this.onEachFeature);
        }
      }
    }
    if (this.onDrawLayerCreated) this.onDrawLayerCreated(undefined);
  };

  drawControllerCreateEvent = async (e: L.DrawEvents.Created) => {
    const { layer } = e;

    // console.log('Drawing type:', layerType);

    if (this.isOpenPopup === false) {
      this.tempCreatedLayer = layer;
      if (this.onDrawLayerCreated) this.onDrawLayerCreated(layer);
    } else {
      statusHelper.displayErrorMessage('Please Choose Layers');
    }
  };

  cancelCreateEvent = () => {
    if (this.tempCreatedLayer) {
      this.editableLayers?.removeLayer(this.tempCreatedLayer);

      if (this.onDrawLayerCreated) {
        this.onDrawLayerCreated(undefined);
      }
    }
  };

  // UPDATE YAPAN YER
  drawControllerUpdateEvent = async (e: L.DrawEvents.Edited) => {
    for (const layer of e.layers.getLayers()) {
      const geojson = layerToGeojson(layer);
      // @ts-ignore
      const uuid = (layer as L.GeoJSON).feature?.properties?.uuid;

      if (uuid) {
        /*
        while editing a drawing object we change the background fillColor and fillOpacity of the object to express its currently editable
        but saving edited object also saves these properties

        so here we turn back to default fillColor and fillOpacity values from default Polygon shape options
      */

        // @ts-ignore
        if (layer instanceof L.Path) {
          const opts = (layer as any).options;
          geojson.properties.style = {
            ...geojson.properties.style,
            color: opts.color,
            opacity: opts.opacity,
            dashArray: opts.dashArray,
            fillColor: opts.fillColor,
            fillOpacity: opts.fillOpacity,
          };
        }

        const updatedItem = await drawenLayerHelper.updateDrawGeoJson(geojson, uuid);
        if (updatedItem) {
          this.layerData[uuid].dbEntry = updatedItem;
        }
      }
    }
  };

  drawControllerDeleteEvent = async (e: L.DrawEvents.Deleted) => {
    const uuids: string[] = [];

    for (const layer of e.layers.getLayers()) {
      // @ts-ignore
      const uuid = (layer as L.GeoJSON).feature?.properties?.uuid;

      if (uuid) {
        uuids.push(uuid);
      }
    }

    await drawenLayerHelper.deleteDrawGeoJsonArray(uuids);
  };

  setIsOpenPopupDrawController = (isOpen: boolean) => {
    this.isOpenPopup = isOpen;
  };

  bindEvents = () => {
    if (!this.eventsBoundStatus) {
      this.map.on(L.Draw.Event.CREATED, (e) => this.drawControllerCreateEvent(e as L.DrawEvents.Created));
      this.map.on(L.Draw.Event.EDITED, async () => {
        const simulatedEvent = {
          layers: {
            getLayers: () => this.editableLayers?.getLayers() || [],
          },
        } as L.DrawEvents.Edited;
        await this.drawControllerUpdateEvent(simulatedEvent);
        this.handleCopyOnEditStop();
      });

      this.map.on(L.Draw.Event.EDITSTOP, () => {
        this.handleCopyOnEditStop();
      });
      this.map.on(L.Draw.Event.DELETED, (e) => this.drawControllerDeleteEvent(e as L.DrawEvents.Deleted));

      // For trace the delete mode
      this.map.on('draw:deletestart', () => {
        this.deleteMode = true;
        this.setRotateModal?.(undefined);
      });

      this.map.on('draw:deletestop', () => {
        this.deleteMode = false;
      });

      this.eventsBoundStatus = true;
    }
  };

  unBindEvents = () => {
    this.map.off(L.Draw.Event.CREATED);
    this.map.off(L.Draw.Event.EDITED);
    this.map.off(L.Draw.Event.DELETED);
    this.map.off('draw:deletestart');
    this.map.off('draw:deletestop');
    this.map.off(L.Draw.Event.EDITSTART);
    this.map.off(L.Draw.Event.EDITSTOP);
  };

  // Geojsonlara eklediğimiz mytag değişkeni sayesinde mapten kaldırmamızı sağlar.
  removeMarkers = () => {
    this.map.eachLayer((layer: any) => {
      if (layer.myTag && layer.myTag === 'drawenLayerGeoJSON') {
        this.map.removeLayer(layer);
      }
    });
  };

  // Çizim toolbarını Mapten kaldırmak için kullanılır.
  removeFromMap = () => {
    if (drawLeafletController) this.map.removeControl(drawLeafletController);

    this.map.removeControl(activeLayersControl);
    this.map.removeControl(customColorPicker);
    this.map.removeControl(customDrawGroupPicker);

    if (this.editableLayers) {
      this.editableLayers.clearLayers();
      this.map.removeLayer(this.editableLayers);
    }

    this.unBindEvents();
  };

  destruct = () => {
    this.activeGroupIds.clear();
    this.layerData = {};
    this.removeFromMap();
    this.removeMarkers();
    geoJsonSocketHelper.closeSocket();
  };
}
